import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filepickermultiple',
  templateUrl: './filepickermultiple.component.html',
  styleUrls: ['./filepickermultiple.component.scss']
})
export class FilepickerMultipleComponent implements OnInit {

  @Input() model?: string;
  @Input() label = 'Upload';
  @Input() accept = 'image/*';
  @Output() modelChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  onUpload(event: any): void {
    this.modelChange.emit(event.originalEvent.body);
  }

}
